import * as React from "react";
const SvgUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M24.59 23L20 18.42L15.41 23L14 21.59L20 15.59L26 21.59L24.59 23Z", fill: "#0B4566" }));
export default SvgUp;
